var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',[_vm._t("header")],2),_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2),_c('page-footer',[_vm._t("footer")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }